// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"296":"708e47fd560a6f87","4690":"34cdbcb2c2a86b89","5217":"a062f8d2e61587a6"}[chunkId] + ".js";
};